/**
 * Invite actions script file
 *
 * @package    Actions
 * @author     Vadym Karpenko <vadym.karpenko@door3.com>
 */

import RegistrationApi from 'Api/registration';

export const REGISTRATION_ITEM_REQUEST = 'REGISTRATION_ITEM_REQUEST';
export const REGISTRATION_ITEM_SUCCESS = 'REGISTRATION_ITEM_SUCCESS';
export const REGISTRATION_ITEM_ERROR = 'REGISTRATION_ITEM_ERROR';

export function loadRegistration (criteria) {
    return function (dispatch) {
        return dispatch({
            request: RegistrationApi.loadItem(criteria),
            requestType: 'REGISTRATION_ITEM',
            successCallback: (response, dispatch) => {
                if (!response.data) {
                    window.location.href =
                        `${ process.env.OLD_APP_HOST }/#/?${ criteria.inviteHash ?
                            'inviteHash' :
                            'gid' }=${ criteria.inviteHash || criteria.groupID }`;

                    return false;
                }

                return dispatch({
                    data: response.data,
                    type: REGISTRATION_ITEM_SUCCESS,
                });
            },
        });
    };
}
